import { req, file, baseUrl } from "./service";

const apis: Record<string, any> = {
  menu: ["g", "login/menu"],
  overview: ["g", "system/overview"],
  // variety
  varietyTree: ["g", "variety/tree"],
  varietyDetail: ["g", "variety/detail"],
  varietySave: ["p", "variety/save"],
  varietySetStatus: ["p", "variety/set-status"],
  varietyRemove: ["p", "variety/remove"],
  // article
  articleList: ["g", "article/datas"],
  articleSave: ["p", "article/save"],
  articleSetStatus: ["p", "article/set-status"],
  articleRemove: ["p", "article/remove"],
  // report
  reportList: ["g", "report/datas"],
  report: ["p", "report/report"],
  reportDownload: "report/download",
  // project
  publishList: ["g", "project/publish"],
  projectSetStatus: ["p", "project/set-status"],
  projectRemove: ["p", "project/remove"],
  // log
  adminLogList: ["g", "admin/logs"],
  // setting
  settingList: ["g", "system/settings"],
  settingSave: ["p", "system/setting"],
};

export async function api(key: string, data = {}) {
  const item = apis[key];
  if (item === undefined) {
    return {
      status: false,
      data: "API NOT FOUND",
    };
  } else {
    return req(item[0], "/" + item[1], data);
  }
}

export async function download(key: string, label: string, data = {}) {
  const item = apis[key];
  if (item === undefined) {
    return {
      status: false,
      data: "API NOT FOUND",
    };
  } else {
    return file(item, label, data);
  }
}

export function apiUpload() {
  const url = "/system/upload";
  return Promise.resolve(baseUrl() + url);
}
